module.exports = __webpack_public_path__ + "media/images/arrive-91ef94ae63ee447ace6fa92c7e775e8e.jpg";